import { Injectable, NgZone } from "@angular/core";
import { Storage } from "@ionic/storage";
import { Router } from "@angular/router";
 import * as firebase from "firebase/app";
//let firebase = require("firebase/app");
import { AngularFireAuth } from "@angular/fire/auth";
import {Observable} from 'rxjs';
import { GooglePlus } from "@ionic-native/google-plus/ngx";
import { Platform} from "@ionic/angular";

@Injectable({
  providedIn: "root"
})
export class FireAuthService {
  user: Observable<firebase.User>;

  constructor(
    public router: Router,
    public ngZone: NgZone,
    public afAuth: AngularFireAuth,
    private gPlus: GooglePlus,
    private platform: Platform,
    private storage: Storage,
    private googlePlus: GooglePlus,
  ) {
   this.user =  this.afAuth.authState;
  }

 



  async nativeGoogleLoginIOS(gPlusUser){
      try{
        return await this.afAuth.signInWithCredential(
          firebase.auth.GoogleAuthProvider.credential(JSON.parse(JSON.stringify(gPlusUser)).idToken)
        );
      }
      catch(err){
          console.log("ios Signin Error:",err);
          
      }
  }

 async nativeGoogleLoginAndroid(gPlusUser){
          try{
            return await this.afAuth.signInWithCredential(
              firebase.auth.GoogleAuthProvider.credential(JSON.parse(JSON.stringify(gPlusUser)).idToken)
            );
          }
          catch(err){
              console.log("android Signin Error:",err);
              
          }
      }

  // Firebase SignInWithPopup
  OAuthProvider(provider) {
    return new Promise((resolve, reject) => {
      return this.afAuth
        .signInWithPopup(provider)
        .then(res => {
          console.log("resss:-", res);
          return this.afAuth.getRedirectResult().then(
            result => {
              console.log("result", result);
              resolve(res);
            },
            err => {
              console.log("result Error", err);
            reject(err);
            }
          );
        })
        .catch(error => {
          console.log("error", error);
          reject(error);
        });
    });
  }

  // Firebase Google Sign-in
  SigninWithGoogle() {
    return new Promise((resolve, reject) => {
      return this.OAuthProvider(new firebase.auth.GoogleAuthProvider())
        .then(res => {
          console.log("Successfully logged in!", res);
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  GoogleLogInWithoutPersist(email,password) {
    let self =this;
    return new Promise((resolve, reject) => {
    return this.afAuth.createUserWithEmailAndPassword(email,password)
      .then((res)=> {
         resolve(res);
        // return self.OAuthProvider(new auth.GoogleAuthProvider())
        // .then(res => {
        //   console.log("Successfully logged in!", res);
        //   resolve(res);
        // })
        // .catch(error => {
        //   reject(error);
        // });
        })
          .catch(error => {
            reject(error);
            console.log("error", error);
          });
    });
  }

  // Firebase Logout
  SignOut() {
    if (this.platform.is("cordova") && this.platform.is("android")) {
        return this.afAuth.signOut().then(() => {
            this.googlePlus.disconnect().then(() =>{
                this.router.navigate(["profile"]);
            })
        });
    }else{
        return this.afAuth.signOut().then(() => {
            this.router.navigate(["profile"]);
        });
    }
    
  }
}

